import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=df980568&scoped=true&"
import script from "./reg.vue?vue&type=script&lang=js&"
export * from "./reg.vue?vue&type=script&lang=js&"
import style0 from "./reg.vue?vue&type=style&index=0&id=df980568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df980568",
  null
  
)

export default component.exports